import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

const getUnitInactiveBySerialImei = async (imei: string, serialNo: string): Promise<IUnitGenericDetailsModel> =>
  axios.get(`/Unit/GetInactiveUnitBySerialImei?serialNo=${serialNo}&imei=${imei}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitInactiveBySerialImei

type Props = {
  config?: QueryConfig<QueryFnType>
  imei: string
  serialNo: string
}

export const useGetUnitInactiveBySerialImei = ({ config, imei, serialNo }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getUnitInactiveBySerialImei', imei, serialNo],
    queryFn: () => getUnitInactiveBySerialImei(imei, serialNo)
  })
